export default "__VITE_ASSET__DjUh1xGW__"